<template>
	<div class="app-convention-hall app-page">
		<van-nav-bar class="app-nav-bar" :title="$t('concubine.concubine')" />
		<div class="games-page__convention-item">
			<van-tabs animated sticky line-width="100px" :swipeable="true">
				<van-tab :title="$t('concubine.city')">
					<div class="profiles-page__card">{{$t("concubine.city_tip")}}</div>
					<div class="profiles-page__address">
						<van-cell-group v-for="(val, key) in addlist" :key="key">
						<van-cell @click="addgo(val)">{{val.name}}</van-cell>
						</van-cell-group>
						<!-- <van-row type="flex" justify="" gutter="65" v-for="(val, key) in addlist" :key="key">
							<van-col span="" offset="" @click="addgo(v)" v-for="(v, k) in val" :key="k">{{ v.name }}</van-col>
						</van-row> -->
					</div>
				</van-tab>
				<van-tab :title="$t('concubine.price')">
					<div class="profiles-page__card">{{$t("concubine.city_tip")}}</div>
					<div class="profiles-page__rig-box">
						<p class="profiles-page__rig-title">{{$t("concubine.pri_resource")}}</p>
						<p class="profiles-page__rig-content">{{$t("concubine.pri_obj")}}</p>
						<p class="profiles-page__rig-title">{{$t("concubine.pri_service")}}</p>
						<p class="profiles-page__rig-content">{{$t("concubine.pric_service_one")}}</p>
						<p class="profiles-page__rig-content">{{$t("concubine.pric_service_two")}}</p>
					</div>
				</van-tab>
			</van-tabs>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			addlist: []
		};
	},
	methods: {
		addgo(data) {
			// if (!localStorage.getItem('token')) {
			// 	this.$router.push({ path: '/auth/login' });
			// } else {
			// }
				this.$router.push({ path: '/profiles/list?id=' + data.id + '&name=' + data.name });
		},
		getAddress() {
			this.$http({
				method: 'get',
				url: 'address_list'
			}).then(res => {
				this.addlist = res.data;
			});
		}
	},
	created() {
		this.getAddress();
	}
};
</script>

<style lang="less" scoped src="./index.styles.less"></style>
